// export const config = {
//   production: false,
// };
export const config = {
  dev_local: false,
  dev_remote: false,
  production: true,
};
